import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import img$1 from '../../../../../assets/images/convatec-logo-horizontal.svg.js';
import img$2 from '../../../../../assets/images/logo-vertical.svg.js';
import img from '../../../../../assets/images/amcare-logo.svg.js';
import css_248z from './footer-logo.scss.js';

class FooterLogo extends s {
    constructor() {
        super(...arguments);
        this.href = '/';
        this.alt = 'Convatec';
        this.ariaText = null;
        this.isAmcare = '';
        this.isDesktop = window.innerWidth >= 1024;
        this._handleResize = () => {
            this.isDesktop = window.innerWidth >= 1024;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this._handleResize);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this._handleResize);
        super.disconnectedCallback();
    }
    getLogo() {
        if (this.isAmcare.trim() !== '')
            return img;
        return this.isDesktop ? img$1 : img$2;
    }
    render() {
        const logo = this.getLogo();
        const ariaLabel = this.ariaText && this.ariaText.trim() !== '' ? this.ariaText : undefined;
        return $ `<a class="footer-logo" href="${this.href}" aria-label="${l(ariaLabel)}"><img class="footer-logo__img" src="${logo}" alt="${this.alt}"></a>`;
    }
}
FooterLogo.styles = css_248z;
__decorate([
    e({ type: String })
], FooterLogo.prototype, "href", void 0);
__decorate([
    e({ type: String })
], FooterLogo.prototype, "alt", void 0);
__decorate([
    e({ type: String })
], FooterLogo.prototype, "ariaText", void 0);
__decorate([
    e({ type: String })
], FooterLogo.prototype, "isAmcare", void 0);
__decorate([
    t()
], FooterLogo.prototype, "isDesktop", void 0);
customElements.define('footer-logo', FooterLogo);

export { FooterLogo };
